import { init } from '@react-navigation/core/lib/commonjs/NavigationActions'
import { isEmpty, isNil, map } from 'lodash'
import moment from 'moment'

const specs = {
  width: 620,
  title: {
    update: 'pages.preventionPlans.modal.update.single.title',
    create: 'pages.preventionPlans.modal.create.single.title'
  },
  okText: {
    update: 'pages.preventionPlans.modal.update.single.okText',
    create: 'pages.preventionPlans.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.preventionPlans.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.preventionPlans.fields.name.title',
        required: 'pages.preventionPlans.fields.name.requiredMessage',
        placeholder: 'pages.preventionPlans.fields.name.placeholder'
      },
      empty: 'common.unknown.male'
    },
    
    // TODO: nouvelle option + revoir l'affichage du isAvenant et isAvenantOf
    typePdp: {
      title: 'pages.preventionPlans.fields.typePdp.title',
      dataIndex: 'typePdp',
      key: 'typePdp',
      formField: {
        type: 'select',
        label: 'pages.preventionPlans.fields.typePdp.title',
        required: 'pages.preventionPlans.fields.typePdp.requiredMessage',
        placeholder: 'pages.preventionPlans.fields.typePdp.placeholder',
        options: [
          {
            id: 'ANNUEL',
            value: 'ANNUEL',
            label: 'pages.preventionPlans.fields.typePdp.options.annual'
          },
          {
            id: 'SPECIFIQUE',
            value: 'SPECIFIQUE',
            label: 'pages.preventionPlans.fields.typePdp.options.specific'
          },
          {
            id: 'AVENANT',
            value: 'AVENANT',
            label: 'pages.preventionPlans.fields.typePdp.options.avenant'
          }
        ]
      },
      empty: 'common.unknown.male'
    },
    companies: {
      title: 'pages.preventionPlans.fields.companies.title',
      dataIndex: 'companies',
      key: 'companies',
      formField: {
        type: 'select',
        mode: 'multiple',
        notFoundContent: null,
        label: 'pages.preventionPlans.fields.companies.title',
        required: 'pages.preventionPlans.fields.companies.requiredMessage',
        placeholder: 'pages.preventionPlans.fields.companies.placeholder'
        // format: company =>
        //   !isNil(company) && !isEmpty(company) ? company.id : undefined
      },
      empty: 'common.unknown.male'
    },
    pdpnum: {
      title: 'pages.preventionPlans.fields.pdpnum.title',
      dataIndex: 'pdpnum',
      key: 'pdpnum',
      onlyForUpdate: true,
      formField: {
        type: 'inputOrSelect',
        label: 'pages.preventionPlans.fields.pdpnum.title',
        required: 'pages.preventionPlans.fields.pdpnum.requiredMessage',
        placeholders: {
          input: 'pages.preventionPlans.fields.pdpnum.placeholders.input',
          select: 'pages.preventionPlans.fields.pdpnum.placeholders.select'
        },
        inputOrSelectRadioLabels: {
          input:
            'pages.preventionPlans.fields.pdpnum.inputOrSelectRadioLabels.input',
          select:
            'pages.preventionPlans.fields.pdpnum.inputOrSelectRadioLabels.select'
        }
      },
      empty: 'common.unknown.male'
    },
    subcontractors: {
      title: 'pages.preventionPlans.fields.companies.title',
      dataIndex: 'subcontractors',
      key: 'subcontractors',
      formField: {
        required: false,
        type: 'select',
        mode: 'multiple',
        notFoundContent: null,
        label: 'pages.preventionPlans.fields.subcontractors.title',
        // required: 'pages.preventionPlans.fields.subcontractors.requiredMessage',
        placeholder: 'pages.preventionPlans.fields.subcontractors.placeholder'
        // format: company =>
        //   !isNil(company) && !isEmpty(company) ? company.id : undefined
      },
      empty: 'common.unknown.male'
    },
    // todo: revoir ça en fonction de typePdp
    isAvenantOf: {
      title: 'pages.preventionPlans.fields.isAvenantOf.title',
      dataIndex: 'isAvenantOf',
      key: 'isAvenantOf',
      formField: {
        visibility: {
          fieldsValues: {
            typePdp: "AVENANT"
          }
        },
        type: 'select',
        notFoundContent: null,
        required: false,
        label: 'pages.preventionPlans.fields.isAvenantOf.title',
        placeholder: 'pages.preventionPlans.fields.isAvenantOf.placeholder'
        // format: company =>
        //   !isNil(company) && !isEmpty(company) ? company.id : undefined
      },
      empty: 'common.unknown.male'
    },
    isSigned: {
      title: 'pages.preventionPlans.fields.isSigned.title',
      dataIndex: 'isSigned',
      key: 'isSigned',
      initialValueTrueFalse: true,
      formField: {
        type: 'checkbox',
        label: 'pages.preventionPlans.fields.isSigned.title',
        placeholder: 'pages.preventionPlans.fields.isSigned.placeholder'
      }
    },
    startDate: {
      title: 'pages.preventionPlans.fields.startDate.title',
      dataIndex: 'startDate',
      key: 'startDate',
      formField: {
        type: 'date',
        label: 'pages.preventionPlans.fields.startDate.title',
        required: 'pages.preventionPlans.fields.startDate.requiredMessage',
        placeholder: 'pages.preventionPlans.fields.startDate.placeholder',
        format: date => moment(date)
      },
      render: date => moment(date).format('L'),
      empty: 'common.unknown.female'
    },
    endDate: {
      title: 'pages.preventionPlans.fields.endDate.title',
      dataIndex: 'endDate',
      key: 'endDate',
      formField: {
        type: 'date',
        label: 'pages.preventionPlans.fields.endDate.title',
        required: 'pages.preventionPlans.fields.endDate.requiredMessage',
        placeholder: 'pages.preventionPlans.fields.endDate.placeholder',
        format: date => moment(date)
      },
      render: date => moment(date).format('L'),
      empty: 'common.unknown.female'
    },comment: {
      title: 'pages.preventionPlans.fields.comment.title',
      dataIndex: 'comment',
      key: 'comment',
      formField: {
        required: false,
        label: 'pages.preventionPlans.fields.comment.title',
        placeholder: 'pages.preventionPlans.fields.comment.placeholder',
        type: 'textarea'
      },
      empty: 'common.unknown.male'
    }
  }
}

export default specs
